import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContracts } from 'products/nomad_insurance/state/contract';
import { findOngoingNomadInsuranceContract, findPolicyForContract } from '../utils';

const useMemberPolicyVersion = (policies, enabled) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.app.user);
  const { contractsIncludingExpired, error } = useSelector(
    (state) => state.nomadInsurance.contract
  );
  const shouldResolve = enabled && isAuthenticated;

  useEffect(() => {
    if (shouldResolve && !contractsIncludingExpired) {
      dispatch(fetchContracts());
    }
  }, [contractsIncludingExpired, dispatch, shouldResolve]);

  const memberVersion = useMemo(() => {
    if (!shouldResolve || !contractsIncludingExpired) return undefined;
    const contract = findOngoingNomadInsuranceContract(contractsIncludingExpired);
    return findPolicyForContract(policies, contract)?.fields.effectiveDate;
  }, [policies, contractsIncludingExpired, shouldResolve]);

  return {
    isAuthenticated,
    isResolving: shouldResolve && !contractsIncludingExpired && !error,
    memberVersion
  };
};

export default useMemberPolicyVersion;
